<template>
  <BCol cols="12">
    <BRow class="custom-inner-table-bg-color rounded-sm py-1" align-v="center">
      <BCol cols="2">
        <p class="text-center">
          {{ classDetails.masterTitle || "-" }}
        </p>
      </BCol>
      <BCol cols="2">
        <p class="text-center">
          <span class="text-info" style="white-space: nowrap">
            {{ customConvertWeekDay(classDetails.startDate) }}
          </span>
          -
          <span class="text-info" style="white-space: nowrap">{{
            customFullDateConvert(classDetails.startDate)
          }}</span>
        </p>
      </BCol>
      <BCol cols="2">
        <p class="text-center">
          از
          <span class="text-primary font-weight-bolder">{{
            customConvertHourAndMinute(classDetails.startDate)
          }}</span>
          تا
          <span class="text-primary font-weight-bolder">{{
            customConvertHourAndMinute(classDetails.endDate)
          }}</span>
        </p>
      </BCol>
      <BCol cols="2">
        <p class="text-center">
          {{ customFullDateConvert(classDetails.deadLine) }} -
          {{ customConvertHourAndMinute(classDetails.deadLine) }}
        </p>
      </BCol>
      <BCol cols="1">
        <p class="text-center">
          <span dir="ltr"
            >{{ classDetails.studentsCount }} / {{ classMaxCapacity }}</span
          >
          نفر
        </p>
      </BCol>
      <BCol cols="1">
        <p v-if="!classDetails.groupClassLink" class="text-center">-</p>
        <div v-else class="w-100 d-flex justify-content-center">
          <a target="_blank" :href="classDetails.groupClassLink">
            <BButton variant="primary">ورود</BButton>
          </a>
        </div>
      </BCol>
      <BCol cols="2">
        <div class="d-flex flex-wrap">
          <BButton
            :disabled="!classDetails.studentsCount"
            @click="renderGroupClassUsersList"
            type="button"
            variant="transparent"
            size="sm"
            v-b-tooltip="'لیست کاربران کلاس'"
            class="w-50"
          >
            <FeatherIcon icon="UsersIcon" size="23" class="text-primary" />
          </BButton>
          <BButton
            @click="renderUpdateClassLinkDialog"
            type="button"
            variant="transparent"
            size="sm"
            class="w-50"
            v-b-tooltip="'ویرایش جزئیات کلاس'"
          >
            <FeatherIcon icon="EditIcon" size="23" class="text-info" />
          </BButton>
          <BButton
            @click="renderGroupClassCancelConfirmationDialog"
            type="button"
            variant="transparent"
            size="sm"
            class="w-50"
            v-b-tooltip="'کنسل کردن کلاس'"
          >
            <FeatherIcon icon="SlashIcon" size="23" class="text-danger" />
          </BButton>
          <BButton
            @click="renderFinishGroupClassConfirmationDialog"
            type="button"
            variant="transparent"
            size="sm"
            class="w-50"
            v-b-tooltip="'اتمام کلاس'"
          >
            <FeatherIcon
              icon="CheckCircleIcon"
              size="23"
              class="text-success"
            />
          </BButton>
        </div>
      </BCol>
    </BRow>
    <UpdateGroupClassLinkDialog
      :dialogId="classDetails.id"
      :selectedGroupClass="classDetails"
      @refetch="refetch"
    ></UpdateGroupClassLinkDialog>
    <CancelGroupClassConfirmationDialog
      :dialogId="classDetails.id"
      :selectedGroupClass="classDetails"
      @refetch="refetch"
    ></CancelGroupClassConfirmationDialog>
    <FinishGroupClassConfirmationDialog
      :dialogId="classDetails.id"
      :selectedGroupClass="classDetails"
      @refetch="refetch"
    >
    </FinishGroupClassConfirmationDialog>
    <GroupClassUsersListDialog
      :dialogId="classDetails.id"
      :studentsList="classDetails.students"
    ></GroupClassUsersListDialog>
  </BCol>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    classDetails: {
      type: Object,
    },
    classMaxCapacity: {
      type: [String, Number],
    },
  },
  methods: {
    refetch() {
      this.$emit("refetch");
    },
    renderGroupClassUsersList() {
      this.$bvModal.show(`group-class-users-list-${this.classDetails.id}`);
    },
    renderUpdateClassLinkDialog() {
      this.$bvModal.show(
        `update-group-class-link-by-master-dialog-${this.classDetails.id}`
      );
    },
    renderGroupClassCancelConfirmationDialog() {
      this.$bvModal.show(
        `cancel-group-class-confirmation-dialog-${this.classDetails.id}`
      );
    },
    renderFinishGroupClassConfirmationDialog() {
      this.$bvModal.show(
        `finish-group-class-confirmation-dialog-${this.classDetails.id}`
      );
    },
  },
  directives: {
    BTooltip: VBTooltip,
  },
  mixins: [timeConvertUtils],
  components: {
    GroupClassUsersListDialog,
    UpdateGroupClassLinkDialog,
    CancelGroupClassConfirmationDialog,
    FinishGroupClassConfirmationDialog,
    BRow,
    BCol,
    BButton,
  },
};
import timeConvertUtils from "@/mixins/timeConvertUtils";
import GroupClassUsersListDialog from "@/views/components/GroupClass/MasterGroupClass/Dialogs/GroupClassUsersListDialog.vue";
import UpdateGroupClassLinkDialog from "@/views/components/GroupClass/MasterGroupClass/Dialogs/UpdateGroupClassLinkDialog.vue";
import CancelGroupClassConfirmationDialog from "@/views/components/GroupClass/MasterGroupClass/Dialogs/CancelGroupClassConfirmationDialog.vue";
import FinishGroupClassConfirmationDialog from "@/views/components/GroupClass/MasterGroupClass/Dialogs/FinishGroupClassConfirmationDialog.vue";
import { BRow, BCol, BButton, VBTooltip } from "bootstrap-vue";
</script>
